import { Card } from '@sravni/react-design-system';
import type { CardColor, CardSize } from '@sravni/react-design-system/dist/types/components/Card/types/Card.types';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import type { ComponentPropsWithoutRef } from 'react';
import React, { forwardRef } from 'react';

import styles from './AdaptiveCard.module.scss';

type TAdaptiveCardProps = ComponentPropsWithoutRef<'div'> & {
  color?: CardColor;
  desktopSize?: CardSize;
  mobileSize?: CardSize;
  isHideCardWrapper?: boolean;
  isWithoutPadding?: boolean;
  isVertical?: boolean;
  className?: string;
};
export const AdaptiveCard = forwardRef<HTMLDivElement, TAdaptiveCardProps>((props, ref) => {
  const {
    desktopSize = 32,
    mobileSize = 16,
    isHideCardWrapper,
    isWithoutPadding,
    children,
    className,
    color = 'dark',
    isVertical,
  } = props;

  const isMobile = useIsMobile();

  if (isHideCardWrapper) {
    return (
      <div
        ref={ref}
        className={className}
      >
        {children}
      </div>
    );
  }

  return (
    <Card
      size={isMobile ? mobileSize : desktopSize}
      color={color}
      className={cn(
        {
          [styles.adaptiveCardWithoutPadding]: isWithoutPadding,
          [styles.adaptiveCardVertical]: isVertical,
        },
        className,
      )}
      ref={ref}
    >
      {children}
    </Card>
  );
});

AdaptiveCard.displayName = 'AdaptiveCard';
